import Slider from '@material-ui/core/Slider';
import React from 'react';

export default function InterestSlider(props) {
	return (
		<>
			<p className="light-gray" style={{ marginBottom: '50px' }}>
				{props.label}
			</p>
			<p>
				<Slider
					valueLabelFormat={value => <span style={{ fontSize: '15px' }}>{value}</span>}
					className="bold-important"
					aria-labelledby="non-linear-slider"
					value={props.value || 0.0} // Use value instead of defaultValue
					marks={[
						{ value: parseInt(0), label: `${parseInt(0)}%` },
						{ value: parseInt(6), label: `${parseInt(6)}%` }
					]}
					max={6}
					min={0}
					onChange={props.onChange}
					step={0.05}
					valueLabelDisplay="on"
				/>
			</p>
		</>
	);
}
